import axios from 'axios';
import { AssistantContext } from '@/config/context';
import { getFilesFromContext } from '@/lib/xstate/machine';

export async function uploadFile(file: File): Promise<string> {
  const filePath = Date.now() + '/' + file.name;
  try {
    const { data: signedUploadUrl } = await axios.post(
      process.env.VUE_APP_FUNCTIONS_URL + '/signedUploadUrl',
      {
        filePath,
        fileType: file.type,
      },
    );

    await axios.put(signedUploadUrl, file, {
      headers: {
        'Content-Type': file.type,
      },
    });

    return filePath;
  } catch (e) {
    console.error(e);
    throw new Error(
      `Es ist ein Fehler Hochladen der Datei '${file.name}' aufgetreten.`,
    );
  }
}

export async function getMailAttachments(
  context: AssistantContext,
): Promise<string[]> {
  return await Promise.all(
    getFilesFromContext(context).map(async file => {
      return await uploadFile(file);
    }),
  );
}
